import type { NavigationRoutingObject } from "@navigationRouting/types";

import type { I18nT } from "@lib/dashboardI18n";

export const oauthMcpSettingsNRO: NavigationRoutingObject = {
  section: "settings",
  heading: (t: I18nT<"dashboard-navigation">) => t("oauth-mcp-settings-nro-heading", "OAuth"),
  pageNameForTracking: () => "OAuth Settings",
  getDeveloperNavigationAllowed: ({ featureOn, hasPermission }) => {
    return (
      featureOn("oauth_mcp_server_enablement") &&
      hasPermission("company", {
        permission: "admin",
      })
    );
  },
  additionalSearchTerms: () => [],
  additionalSearchableFeatures: () => ({}),
};
